import { render, staticRenderFns } from "./vipCode8-3.vue?vue&type=template&id=5d4ece64&scoped=true&"
import script from "./vipCode8-3.vue?vue&type=script&lang=ts&"
export * from "./vipCode8-3.vue?vue&type=script&lang=ts&"
import style0 from "./vipCode8-3.vue?vue&type=style&index=0&id=5d4ece64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ece64",
  null
  
)

export default component.exports